import React from 'react';

import { Grid, Tabs, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const REPORT_TYPES = {
  ACTIVITY_REPORT: 'activity-report',
  COACH_REPORT: 'coach-report',
  TEAM_PROGRESS_REPORT: 'team-progress',
  MOMENTS_REPORT: 'moments-report',
  ASSIGNMENT_PATH_REPORT: 'assignment-path-report',
  AI_TRAINING_REPORT: 'ai-training-report',
  OUTSTANDING_REPORT: 'outstanding-report',
  SIMULATION_SKILLS_REPORT: 'simulation-skills-report',
};

const reportTypeTabs = {
  [REPORT_TYPES.ACTIVITY_REPORT]: {
    value: REPORT_TYPES.ACTIVITY_REPORT,
    verbose: 'Activity Report',
    showOnlyToAdmin: true,
  },
  [REPORT_TYPES.MOMENTS_REPORT]: {
    value: REPORT_TYPES.MOMENTS_REPORT,
    verbose: 'Moments Report',
  },
  [REPORT_TYPES.TEAM_PROGRESS_REPORT]: {
    value: REPORT_TYPES.TEAM_PROGRESS_REPORT,
    verbose: 'Team Progress',
  },
  [REPORT_TYPES.COACH_REPORT]: {
    value: REPORT_TYPES.COACH_REPORT,
    verbose: 'Coach Report',
    showOnlyToAdmin: true,
  },
  [REPORT_TYPES.OUTSTANDING_REPORT]: {
    value: REPORT_TYPES.OUTSTANDING_REPORT,
    verbose: 'Outstanding Report',
  },
  [REPORT_TYPES.ASSIGNMENT_PATH_REPORT]: {
    value: REPORT_TYPES.ASSIGNMENT_PATH_REPORT,
    verbose: 'Assignment Report',
  },
  [REPORT_TYPES.AI_TRAINING_REPORT]: {
    value: REPORT_TYPES.AI_TRAINING_REPORT,
    verbose: 'AI Training Report',
    showOnlyToAdmin: true,
  },
  [REPORT_TYPES.SIMULATION_SKILLS_REPORT]: {
    value: REPORT_TYPES.SIMULATION_SKILLS_REPORT,
    verbose: 'Simulation Skills Report',
  },
};

const styles = () => ({
  tabsRoot: {
    overflowX: 'scroll !important',

    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',

    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

class ReportTypeTabs extends React.PureComponent {
  render() {
    const {
      isAdmin,
      classes,
      selectedTab,
      onTabChange,
      isFromTruGreen,
    } = this.props;

    return (
      <Tabs
        value={selectedTab}
        classes={{
          scroller: classes.tabsRoot,
        }}
        onChange={async (e, data) => { await onTabChange(e, data); }}
        indicatorColor="primary"
        textColor="primary"
      >
        {Object.values(reportTypeTabs).map(({
          value,
          verbose,
          showOnlyToAdmin,
          filterTruGreen,
        }) => {
          const adminOnlyCheck = !showOnlyToAdmin || isAdmin;
          const blockTruGreenCheck = !isAdmin || !isFromTruGreen || !filterTruGreen;

          return (
            (adminOnlyCheck && blockTruGreenCheck) && (
              <Tab
                key={value}
                value={value}
                label={verbose}
              />
            )
          );
        })}
      </Tabs>
    );
  }
}

export default withStyles(styles)(ReportTypeTabs);
